"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AccountSelectError = require("./AccountSelectError");
Object.keys(_AccountSelectError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccountSelectError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccountSelectError[key];
    }
  });
});